import { withStyles } from '@material-ui/core';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import Typography from '@material-ui/core/Typography';
import { useEffect, useState } from 'react';

const styles = () => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: 'whitesmoke',
        padding: '30px',
        border: 'none',
        width: '80vw',
        maxHeight: '60vh',
        overflow: 'auto',
    },
});

function PopupModal({
    classes,
    liveObjData: { isOfflinePackageFound, text, isCheckClicked } = {
        liveObjData: {
            isOfflinePackageFound: false,
            text: '',
            isCheckClicked: false,
        },
    },
    handleResetPackageInLiveObject,
    protocolV11DecryptedData,
    handleClearProtocolV11DecryptedData = null,
    headerText = null,
    data = null,
    openModal = null,
    setOpenModal = null,
}) {
    const [defaultOpen, setDefaultOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [modalText, setModalText] = useState('');

    const open = openModal !== null ? openModal : defaultOpen;
    const setOpen = setOpenModal !== null ? setOpenModal : setDefaultOpen;

    const handleClose = () => {
        setOpen(false);

        if (handleClearProtocolV11DecryptedData) {
            handleClearProtocolV11DecryptedData();
        }
    };

    const setModalHeader = () => {
        if (!modalText) {
            return '';
        }

        if (headerText) {
            return headerText;
        }

        if (protocolV11DecryptedData) {
            return 'Pakiet zdekodowany:';
        }

        return isError ? 'Problem z odnalezieniem pakietu:' : 'Odnaleziony pakiet offline:';
    };

    useEffect(() => {
        if (protocolV11DecryptedData) {
            setOpen(true);
            setModalText(protocolV11DecryptedData);
        }
    }, [protocolV11DecryptedData]);

    useEffect(() => {
        if (isCheckClicked && text) {
            setOpen(true);
            setIsError(!isOfflinePackageFound);
            setModalText(text);
            handleResetPackageInLiveObject();
        }
    }, [text, isOfflinePackageFound, isCheckClicked]);

    useEffect(() => {
        setModalText(data);
        setModalHeader(headerText);
    }, [data, headerText]);

    return (
        <Modal
            className={classes.modal}
            open={open}
            disablePortal={true}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}>
            <Fade in={open}>
                <div className={classes.paper}>
                    <Typography variant="h5" gutterBottom color={isError ? 'error' : 'textPrimary'}>
                        {setModalHeader()}
                    </Typography>
                    <p
                        style={{
                            display: 'block',
                            overflowWrap: 'break-word',
                            maxWidth: '100%',
                        }}>
                        {modalText}
                    </p>
                </div>
            </Fade>
        </Modal>
    );
}

export default withStyles(styles)(PopupModal);
